<template>
  <b-card
    no-body
    class="p-3"
  >
    <b-row >
      <b-col
        cols="12"
      >
        <validation-observer ref="formRef">
          <b-form @submit.prevent>
            <b-row>
              <!-- Cashbank Account Field -->
              <b-col cols="12" md="3">
                <b-form-group
                  :label="$t(`apps.transactions.purchase.goodsRecipient.singular.payFrom`)"
                  label-for="cashbank-account"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cashbank"
                    rules="required"
                  >
                    <v-select
                      v-if="company.plan_id > 2"
                      id="cash-bank-account"
                      ref="firstFocusSelectInput"
                      class="select-size-sm"
                      v-model="form.cashbankId"
                      :options="LOV.cashbankCodeAccounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <v-select
                      v-else
                      id="cash-bank-account"
                      ref="firstFocusSelectInput"
                      class="select-size-sm"
                      v-model="form.accountId"
                      :options="LOV.cashBankAccounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Date Field -->
              <b-col cols="12" md="3">
                <b-form-group
                  :label="$t('globalSingular.date')"
                  label-for="date"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="date"
                    rules="required"
                  >
                    <flat-pickr
                      id="date"
                      :config="dateFormat"
                      v-model="form.date"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                      class="form-control form-control-sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Invoice Field -->
              <b-col cols="12" md="3">
                <b-form-group
                  :label="$t('globalSingular.code')"
                  label-for="code"
                >
                  <!-- <validation-provider
                    #default="{ errors }"
                    name="code"
                    rules="required"
                  > -->
                    <b-form-input
                      id="code"
                      size="sm"
                      v-model="form.code"
                      :placeholder="$t('globalSingular.auto')"
                      :disabled="actions.isPreview"
                    />
                    <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                  <!-- </validation-provider> -->
                </b-form-group>
              </b-col>

              <!-- Tags Field -->
              <b-col cols="12" md="3">
                <b-form-group
                  :label="$t('globalSingular.tags')"
                  label-for="tags"
                >
                  <v-select
                    v-model="form.tags"
                    id="tags"
                    class="select-size-sm"
                    label="name"
                    taggable
                    multiple
                    push-tags
                    :options="LOV.tags"
                    :reduce="field => field.id"
                    :create-option="field => ({id: Date.now(), name: field})"
                    @option:created="pushTags"
                    :searchable="!actions.isPreview"
                    :selectable="option => !actions.isPreview"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="my-1">
              <!-- Transaction No Field -->
              <b-col cols="12" md="3">
                <b-form-group
                  :label="$t(`globalSingular.supplier`)"
                  label-for="contacts"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="contact"
                    rules="required"
                  >
                    <v-select
                      class="select-size-sm"
                      id="contacts"
                      v-model="form.contactId"
                      :options="LOV.contacts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="3" class="d-flex align-items-center">
                <b-button
                  class="mb-sm-1 mb-md-0"
                  :variant="actions.isPreview ? 'outline-secondary' : 'primary'"
                  :disabled="!form.contactId"
                  @click="getOutstandingInvoice(form.contactId)"
                >
                  <!-- <feather-icon
                    icon="ArrowLeftIcon"
                  /> -->
                  {{ $t('globalActions.generate') }}
                  <!-- Generate -->
                </b-button>
              </b-col>
            </b-row>


            <b-table
              id="refFormTable"
              ref="refFormTable"
              responsive
              no-provider-paging
              no-provider-filtering
              :fields="tableColumns"
              :items="detailInvoicePayment"
              primary-key="id"
              show-empty
              class="position-relative mt-2"
            >
              <!-- Custom Header Column -->
              <template #head(actions)>
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="mx-auto"
                />
              </template>
              <!-- Styling width -->
              <!-- Column: Account -->
              <!-- <template #cell(invoiceId)="{ index }">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="account"
                    rules="required"
                    :vid="`detail-${index}`"
                  >
                    <v-select
                      id="account-type"
                      v-model="form.details[index].accountId"
                      :options="LOV.accounts"
                      :reduce="field => field.id"
                      label="label"
                      :state="errors.length > 0 ? false:null"
                      :disabled="actions.isPreview"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template> -->
              <!-- Column: Invoice No -->
              <template #cell(rowNumber)="{ index }">
                <b-form-group>
                    <b-form-input size="sm" v-model="form.details[index].rowNumber" disabled />
                    <!-- <span>{{form.details[index].rowNumber}}</span> -->
                </b-form-group>
              </template>
              <!-- Column: Invoice No -->
              <template #cell(invoiceNo)="{ index }">
                <b-form-group>
                    <b-form-input size="sm" v-model="form.details[index].invoiceNo" disabled />
                </b-form-group>
              </template>
              <!-- Column: Invoice Amount -->
              <template #cell(billAmount)="{ index }">
                <b-form-group>
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].billAmount"
                      class="form-control text-right form-control-sm"
                      :options="numeric"
                      placeholder="10,000"
                      disabled
                    />
                </b-form-group>
              </template>
              <!-- Column: Outstanding Amount -->
              <template #cell(outstandingAmount)="{ index }">
                <b-form-group>
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].outstandingAmount"
                      class="form-control text-right form-control-sm"
                      :options="numeric"
                      placeholder="10,000"
                      disabled
                    />
                </b-form-group>
              </template>
              <!-- Column: PaymentAmount -->
              <template #cell(amount)="{ index }">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="amount"
                    :rules="`required|${!actions.isPreview ? `max_value:${form.details[index].outstandingAmount}` : ''}`"
                    :vid="`detail-${index}`"
                  >
                    <cleave
                      :key="index"
                      v-model.number="form.details[index].amount"
                      :state="errors.length > 0 ? false:null"
                      class="form-control text-right form-control-sm"
                      :options="numeric"
                      placeholder="10,000"
                      :disabled="actions.isPreview"
                      @blur="sumAmount"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="{ index }">
                <b-button
                  variant="flat-danger"
                  class="btn-icon invoice-edit-input"
                  :disabled="form.details.length <= 1"
                  @click="removeRow(form.details[index].rowNumber)"
                >
                  <feather-icon icon="MinusIcon" />
                </b-button>
              </template>
              <!-- Costum Footer -->
              <template v-slot:custom-foot="{}">
                <b-tr>
                  <b-td class="pl-0" colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="text-right">
                    <div class="h5 mb-0 font-weight-bolder">{{ $t('globalSingular.totalPaymentAmount') }}</div>
                  </b-td>
                  <b-td class="text-right">
                    <div class="h5 mb-0 font-weight-bolder">{{ formatCurrency(form.amount) }}</div>
                  </b-td>
                  <b-td>&nbsp;</b-td>
                </b-tr>
                <b-tr v-for="(field, index) in deductionPayment" :key="index" >
                  <b-td class="border-0 pl-0 " colspan="1">
                    <b-form-group label="Deduction to Invoice">
                      <validation-provider
                        #default="{ errors }"
                        name="account"
                        rules="required"
                        :vid="`detail-${field.rowNumber - 1}`"
                      >
                        <v-select
                          class="select-size-sm"
                          id="invoice-deduction-id"
                          v-model="form.details[field.rowNumber - 1].invoiceId"
                          :options="LOV.outstandingInvoices"
                          :reduce="field => field.id"
                          label="code"
                          :disabled="actions.isPreview"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-td>
                  <b-td class="border-0 align-top pl-5" colspan="2">
                    <b-form-group label="Deduction Account">
                      <validation-provider
                        #default="{ errors }"
                        name="account"
                        rules="required"
                        :vid="`detail-${field.rowNumber - 1}`"
                      >
                        <v-select
                          class="select-size-sm"
                          id="deduction-type"
                          v-model="form.details[field.rowNumber - 1].deductionAccountId"
                          :options="LOV.accounts"
                          :reduce="field => field.id"
                          label="label"
                          :disabled="actions.isPreview"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-td>
                  <b-td class="border-0 align-top text-right">
                    <b-form-group label="Deduction Amount">
                      <validation-provider
                        #default="{ errors }"
                        name="amount"
                        :rules="`required|max_value:${form.details[index].amount}`"
                        :vid="`detail-${field.rowNumber - 1}`"
                      >
                        <cleave
                          :key="field.rowNumber - 1"
                          v-model.number="form.details[field.rowNumber - 1].deductionAmount"
                          :state="errors.length > 0 ? false:null"
                          class="form-control text-right text-danger form-control-sm"
                          :options="numeric"
                          placeholder="10,000"
                          :disabled="actions.isPreview"
                          @blur="sumAmount"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-td>
                  <b-td class="border-0">
                    <b-button
                      v-if="!actions.isPreview"
                      variant="flat-danger"
                      class="btn-icon invoice-edit-input"
                      @click="removeRow(field.rowNumber)"
                    >
                      <feather-icon icon="MinusIcon" />
                    </b-button>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-td class="border-0 pl-0 " colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="border-0 text-right">
                    <!-- <div class="h5 mb-0 font-weight-bolder">{{ $t('globalSingular.totalPaymentAmount') }}</div> -->
                    &nbsp;
                  </b-td>
                  <b-td class="border-0 text-right">
                    <b-button
                      v-if="!actions.isPreview"
                      variant="flat-primary"
                      class="btn-icon invoice-edit-input"
                      @click="addDeduction"
                    >
                      <feather-icon icon="PlusIcon" />
                      {{ $t('apps.transactions.purchase.goodsRecipient.actions.addDeduction') }}
                    </b-button>
                  </b-td>
                  <b-td class="border-0">&nbsp;</b-td>
                </b-tr>
                <b-tr>
                  <b-td class="pl-0 border-0" colspan="2">
                    &nbsp;
                  </b-td>
                  <b-td class="text-right border-0">
                    <div class="h4 mb-0 font-weight-bolder">{{ $t('globalSingular.moneyReceived') }}</div>
                  </b-td>
                  <b-td class="text-right border-0">
                    <div class="h4 mb-0 font-weight-bolder">{{ totalMoneyWillReceive }}</div>
                  </b-td>
                  <b-td class="border-0">&nbsp;</b-td>
                </b-tr>
              </template>
            </b-table>

            <b-row>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$t('globalSingular.notes')"
                  label-for="notes"
                >
                  <b-form-textarea
                    id="notes"
                    size="sm"
                    v-model="form.description"
                    :placeholder="!actions.isPreview ? $t('globalSingular.description') : null"
                    :disabled="actions.isPreview"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="mt-3 d-flex flex-sm-column flex-md-row justify-content-between">
              <b-button
                class="mb-sm-1 mb-md-0"
                :variant="actions.isPreview ? 'outline-secondary' : 'outline-primary'"
                :to="{ name: 'apps-transactions-purchase-payment-list' }"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                />
                {{ $t('globalActions.backToList') }}
              </b-button>

              <b-button
                v-if="actions.isPreview"
                class=" mb-sm-1 mb-md-0"
                variant="outline-danger"
                @click="handleDelete"
              >
                <feather-icon
                  icon="Trash2Icon"
                />
                {{ $t('globalActions.delete') }}
              </b-button>

              <b-button
                v-if="!actions.isPreview"
                variant="primary"
                type="submit"
                @click="handleSubmit"
              >
                <feather-icon
                  icon="SaveIcon"
                />
                {{ actions.isEditMode ? $t('globalActions.update') : $t('globalActions.create') }}
              </b-button>

              <!-- <b-button
                v-else
                variant="outline-primary"
                @click="changeToEdit"
              >
                <feather-icon
                  icon="EditIcon"
                />
                {{ $t('globalActions.changeToEdit') }}
              </b-button> -->
            </div>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BTr,
  BTd,
  BFormGroup,
  BFormInput,
  BForm,
  BFormTextarea,
  BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import { ref, onMounted, computed } from '@vue/composition-api'
import flatPickr from 'vue-flatpickr-component'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, maxValue } from '@validations'
import { formatCurrency } from '@/utils/formatter'
import VuexStore from '@/store'


import useFormResource from '@/comp-functions/useFormResource'
import usePushTags from '@/comp-functions/utils/usePushTags'
import useLocalization from '@/comp-functions/utils/useLocalization'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BTr,
    BTd,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    Cleave
  },
  setup () {
    const {
      paramsId,
      // routeParams,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    } = useFormResource({ url: 'transaction/purchase/payment', localeContextPath: 'apps.transactions.purchase.goodsRecipient.singular.payment', redirectPathName: 'apps-transactions-purchase-payment' })

    const company = computed(() => {
      return VuexStore.state.user.currentCompany
    })

    const { $t } = useLocalization()

    const LOV = ref({
      cashbankAccounts: [],
      cashbankCodeAccounts: [],
      contacts: [],
      accounts: [],
      tags: [],
      outstandingInvoices: []
    })

    const getCashbankAccount = async () => {
      LOV.value.cashbankAccounts = await get({ url: 'master/accounts/child?account_subtype_code=CASHBANK'})
    }

    const getCashbankCode = async () => {
      LOV.value.cashbankCodeAccounts = await get({ url: 'master/cashbank'})
    }

    const getAccounts = async () => {
      LOV.value.accounts = await get({ url: 'master/accounts/child'})
    }

    const getContacts = async () => {
      LOV.value.contacts = await get({ url: 'value/contact/supplier'})
    }

    const getTags = async () => {
      LOV.value.tags = await get({ url: 'value/tag'})
    }

    const tableColumns = ref([])

    const form = ref({
      accountId: '',
      cashbankId: '',
      contactId: '',
      code: '',
      paymentTypeCode: '',
      date: '',
      tags: [],
      description: '',
      amount: 0,
      deductionAmount: 0,
      details: [
        {
          rowNumber: null,
          invoiceId: null,
          invoiceNo: null,
          billAmount: null,
          outstandingAmount: null,
          amount: null,
          deductionAccountId: null,
          deductionAmount: null
        }
      ]
    })

    const getOutstandingInvoice = async id => {
      LOV.value.outstandingInvoices = await get({ url: `value/outstanding-purchase-invoice?id=${id}`})
      form.value.details = LOV.value.outstandingInvoices.map((invoice, index) => {
        return {
          rowNumber: index++,
          invoiceId: invoice.id,
          invoiceNo: invoice.code,
          billAmount: parseFloat(invoice.sum_of_bill_amount) || 0,
          outstandingAmount: parseFloat(invoice.outstanding_amount) || 0,
          amount: parseFloat(invoice.amount) || 0,
          deductionAccountId: null,
          deductionAmount: 0
        }
      })
    }

    const dateFormat = ref({ dateFormat: 'd/m/Y', allowInput: true })

    const numeric = ref({
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })

    /**
     * @remark sum of amount and deduction amount when these value change
    */
    const sumAmount = () => {
      form.value.amount = form.value.details.reduce((accumulator, {amount}) => accumulator + amount, 0)
      form.value.deductionAmount = form.value.details.reduce((accumulator, {deductionAmount}) => accumulator + deductionAmount, 0)
    }

    // will get data to show the preview
    const getDataPreview = async () => {
      const data = await get({ url: `transaction/purchase/payment/${paramsId}`})
      // getOutstandingInvoice(data.contact_id)
      form.value.accountId = data.account_id
      if (company.value.plan_id > 2) {
        form.value.cashbankId = data.cashbank_id
      }
      form.value.accountId = data.account_id
      form.value.contactId = data.contact_id
      form.value.code = data.code
      form.value.paymentTypeCode = data.payment_type_code
      form.value.date = data.date
      form.value.dueDate = data.due_date
      form.value.tags = data.tags.map(tag => parseInt(tag))
      form.value.description = data.description
      form.value.amount = parseFloat(data.amount)
      form.value.deductionAmount = parseFloat(data.deduction_amount)
      form.value.details = data.details.map(field => {
        const deductionAmount = parseFloat(field.deduction_amount)
        return {
          rowNumber: field.row_number,
          invoiceId: field.invoice_id,
          invoiceNo: !deductionAmount ? field.invoice.code : '',
          billAmount: !deductionAmount ? parseFloat(field.invoice.sum_of_bill_amount) : 0,
          outstandingAmount: !deductionAmount ? parseFloat(field.invoice.outstanding_amount) : 0,
          amount: !deductionAmount ? parseFloat(field.amount) : 0,
          deductionAccountId: field.deduction_account_id,
          deductionAmount
        }
      })
    }

    // add deduction amount
    const addDeduction = () => {
      form.value.details.push({
        rowNumber: form.value.details.length + 1,
        invoiceId: null,
        invoiceNo: '',
        billAmount: 0,
        outstandingAmount: 0,
        amount: 0,
        deductionAccountId: null,
        deductionAmount: null
      })
    }

    const totalMoneyWillReceive = computed(() => {
      const total = form.value.amount - form.value.deductionAmount
      return formatCurrency(total)
    })

    const detailInvoicePayment = computed(() => form.value.details.filter(field => field.billAmount > 0))
    const deductionPayment = computed(() => form.value.details.filter(field => field.billAmount === 0))

    // Remove row deduction / payment list
    const removeRow =  (rowNumber) => {
      const index = form.value.details.findIndex(field => field.rowNumber === rowNumber)
      form.value.details.splice(index, 1)
      sumAmount()
    }

    onMounted(() => {
      getCashbankAccount()
      getAccounts()
      getTags()
      getContacts()
      if (paramsId) {
        actions.value.isPreview = true
        getDataPreview()
      }
      if (company.value.plan_id > 2) {
        getCashbankCode()
      }
      tableColumns.value = [
        // { key: 'rowNumber', label: '#', width: '10%', thClass: 'bg-transparent pl-0', tdClass: 'align-top pl-0' },
        { key: 'invoiceNo', label: $t('apps.transactions.purchase.goodsRecipient.singular.invoiceNo'), width: '24%', thClass: 'bg-transparent pl-0 width-25-per', tdClass: 'align-top pl-0' },
        { key: 'billAmount', label: $t('apps.transactions.purchase.goodsRecipient.singular.invoiceAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'outstandingAmount', label: $t('apps.transactions.purchase.goodsRecipient.singular.outstandingAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'amount', label: $t('apps.transactions.purchase.goodsRecipient.singular.paymentAmount'), width: '24%', thClass: 'bg-transparent text-right width-25-per', tdClass: 'align-top text-right'},
        { key: 'actions', width: '12%', thClass: 'bg-transparent text-right width-10-per  pr-0', tdClass: 'align-top text-right pr-0'}
      ]
    })

    const { pushTagsToAPI } = usePushTags()
    const pushTags = async newTag => {
      const id = await pushTagsToAPI(newTag)
      form.value.tags[form.value.tags.findIndex(val => val === newTag.id)] = id
    }

    return {
      company,
      getOutstandingInvoice,
      pushTags,
      required,
      maxValue,
      LOV,
      tableColumns,
      detailInvoicePayment,
      deductionPayment,
      form,
      addDeduction,
      removeRow,
      totalMoneyWillReceive,
      dateFormat,
      formatCurrency,
      sumAmount,
      numeric,
      paramsId,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    }
  },
  methods: {
    handleDelete () {
      this.destroy(this.$swal)
    },
    handleSubmit () {
      this.store({
        $swal: this.$swal,
        data: this.form
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
